import PropTypes from 'prop-types';
import React from 'react';
import { ConnectFacebook, ConnectionOptions, EligibilityCheck, ExistingConnection, MigrationRequirements } from '../connection';
import { CONNECTION_OPTIONS } from '../utilities/constants';

const StepContent = ({
  step,
  connectionOption,
  existingStep,
  eligibilityStatus,
  eligibilityStep,
  setEligibilityStep,
  phoneValidationOption,
  subStep,
  onOptionChange,
  onPhoneValidationChange,
  loginStatus,
  isLoggedIn,
  onPhoneNumberSelect,
}) => {
  switch (step) {
    case 1:
      return (
        <ConnectionOptions connectionOption={connectionOption} onOptionChange={onOptionChange} />
      );
    case 2:
      if (connectionOption === CONNECTION_OPTIONS.NEW) {
        return (
          <EligibilityCheck
            eligibilityStatus={eligibilityStatus}
            eligibilityStep={eligibilityStep}
            setEligibilityStep={setEligibilityStep}
            phoneValidationOption={phoneValidationOption}
            subStep={subStep}
            onPhoneValidationChange={onPhoneValidationChange}
          />
        );
      } else {
        return existingStep === 1 ? (
          <ExistingConnection connectionOption={connectionOption} onOptionChange={onOptionChange} />
        ) : (
          <MigrationRequirements />
        );
      }
    case 3:
    case 4:
      return (
        <ConnectFacebook
          step={step}
          loginStatus={loginStatus}
          isLoggedIn={isLoggedIn}
          onPhoneNumberSelect={onPhoneNumberSelect}
        />
      );
    default:
      return null;
  }
};

StepContent.propTypes = {
  step: PropTypes.number.isRequired,
  connectionOption: PropTypes.string,
  existingStep: PropTypes.number,
  eligibilityStatus: PropTypes.shape({
    step1: PropTypes.string,
    step2: PropTypes.string,
  }),
  eligibilityStep: PropTypes.number,
  setEligibilityStep: PropTypes.func,
  phoneValidationOption: PropTypes.string,
  subStep: PropTypes.string,
  onOptionChange: PropTypes.func,
  onPhoneValidationChange: PropTypes.func,
  loginStatus: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  onPhoneNumberSelect: PropTypes.func,
};

StepContent.defaultProps = {
  connectionOption: '',
  existingStep: 1,
  eligibilityStatus: { step1: '', step2: '' },
  eligibilityStep: 1,
  phoneValidationOption: '',
  subStep: '',
  loginStatus: '',
  isLoggedIn: false,
};

export default StepContent;
